import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Subscription } from 'rxjs';
import { CRMEtapaFunil } from 'src/app/models/crm/crmetapa-funil';
import { CRMFiltroOportunidade } from 'src/app/models/crm/crmfiltro-oportunidade';
import { CRM } from 'src/app/models/crm/crmfunil';
import { CRMOportunidade } from 'src/app/models/crm/crmoportunidade';
import { Funcionario } from 'src/app/models/funcionario';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmService } from 'src/app/services/crm/crm.service';
import { CrmoportunidadeService } from 'src/app/services/crm/crmoportunidade.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { AlterarStatusOportunidadeComponent } from './alterar-status-oportunidade/alterar-status-oportunidade.component';
import { CadastrarOportunidadeComponent } from './cadastrar-oportunidade/cadastrar-oportunidade.component';
import { CRMContato } from 'src/app/models/crm/crmcontato';
import { FiltroOportunidadeComponent } from './filtro-oportunidade/filtro-oportunidade.component';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { PerfilDoUsuario } from 'src/app/models/enum';
import { CRMHierarquiaUsuario } from 'src/app/models/crmhierarquia-usuario';
import { CRMHierarquiaUsuarioService } from 'src/app/services/crmhierarquia-usuario.service';
import { FuncionariosModalComponent } from '../modals/funcionarios-modal/funcionarios-modal.component';
import { CardSemUsuarioComponent } from "./card-sem-usuario/card-sem-usuario.component";

export interface TransferenciaOportunidade {
  idUsuario: Number;
  oportunidades: CRMOportunidade[];
}

declare const $: any;

@Component({
  selector: 'app-oportunidade',
  templateUrl: './oportunidade.component.html',
  styleUrls: ['./oportunidade.component.scss']
})
export class OportunidadeComponent implements OnInit {
  // variáveis
  etapas: CRMEtapaFunil[] = [];
  carregando = true;
  campoOrdenacao = 'dtstatus';
  ordenarDesc = true;
  editavel = true;
  crms: CRM[] = [];
  crmSelecionado;
  estaNaHierarquia = false;
  datePipe = new DatePipe('pt-BR');
  classeStatus = 'text-info';
  crmPadrao;

  trabalhaComAssinatura = false;
  administrador = false;
  selecaoTodos = false;
  confirmarMudancaEtapa = false;

  visualizacaoSelecionada = 0;

  etapasFiltro: CRMEtapaFunil[] = [];
  oportunidades: CRMOportunidade[] = [];

  filtroOportunidade: CRMFiltroOportunidade = {
    campoOrdenacao: 'dtabertura', ascDesc: 'desc', tags: [],
    idCRM: 0, status: 0, idResposta: 0, oportunidade: '', idCanalDeVenda: 0, periodo: 0,
    dtInicio: new Date(), dtFim: new Date(), idOrdenacao: 3, usuarios: [-1], cidade: '', idEtapa: 0, nomeContato: '', anotacaoAtividade: '',
    idOportunidade: null, numeroInstalacaoGeradora: '', numeroInstalacaoRecebedora: '', numeroOrcamento: ''
  };

  somenteDonoVeValor = false;

  usuarioLogado: UsuarioLogado;
  idUsuarioAtual = 0;
  PerfilDoUsuario = PerfilDoUsuario;
  perfil: PerfilDoUsuario;
  vendedores: CRMHierarquiaUsuario[] = [];

  podeCriarOportunidade = true;

  public config: PerfectScrollbarConfigInterface = { suppressScrollX: false, swipeEasing: false, useBothWheelAxes: false };
  public configCard: PerfectScrollbarConfigInterface = {};

  private franquiaSubscription$: Subscription;

  constructor(
    private oportunidadeService: CrmoportunidadeService,
    private utilitarioService: UtilitarioService,
    private router: Router,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private crmService: CrmService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    public dialog: MatDialog,
    private funcionarioService: FuncionarioService,
    private relatorioService: RelatorioService,
    public breakpointObserver: BreakpointObserver,
    private empresaService: PremissasService,
    private titleService: Title
  ) {
    titleService.setTitle('GI - CRM');
  }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();
    this.idUsuarioAtual = Number((await this.globalService.consultaUsuario()).id);
    this.usuarioLogado = await this.globalService.consultaUsuario();

    // this.trabalhaComAssinatura = this.globalService.trabalhaComAssinatura();

    // verifica configuração da empresa
    // this.carregandoService.mostra('buscaConfEmpresa');
    // this.empresaService.crmVisualizarValor().subscribe(resp => {
    //   this.carregandoService.esconde('buscaConfEmpresa');

    //   this.somenteDonoVeValor = resp.valor;

    // }, (erro) => {
    //   this.carregandoService.esconde('buscaConfEmpresa');
    //   this.notificacaoService.erro(erro);
    // });

    // verifica confirmação de mudança de etapa
    // this.carregandoService.mostra('confirmarMudancaEtapa');
    // this.empresaService.confirmarMudancaEtapa().subscribe(resp => {
    //   this.carregandoService.esconde('confirmarMudancaEtapa');

    //   this.confirmarMudancaEtapa = resp.valor;

    // }, (erro) => {
    //   this.carregandoService.esconde('confirmarMudancaEtapa');
    //   this.notificacaoService.erro(erro);
    // });

    if (localStorage.getItem('filtroOportunidade') !== null) {
      this.filtroOportunidade = JSON.parse(localStorage.getItem('filtroOportunidade'));
    }

    this.verificaExistenciaNaHierarquia();
    this.buscarFuncionario();
  }

  trocouCRM() {
    this.buscarEtapas();
  }

  buscarStatus(oportunidade: CRMOportunidade) {

    switch (oportunidade.status) {
      case 0:

        return 'Aberta';

      case 1:

        return this.crms.find(c => c.id === this.crmSelecionado).textoPerda;

      case 2:

        return this.crms.find(c => c.id === this.crmSelecionado).textoGanho;

      case 3:

        return 'Congelada';

      case 4:

        return 'Excluída';

      default:
        break;
    }
  }

  alterarVisualizacao(visualizacao) {
    if (this.visualizacaoSelecionada === visualizacao) {
      return;
    }

    this.visualizacaoSelecionada = visualizacao;

    if (this.visualizacaoSelecionada === 0) {
      this.buscarOportunidades();
    } else {
      this.buscarOportunidadesLista();
    }
  }

  formataData(data, formato) {
    return this.datePipe.transform(new Date(data), formato);
  }

  verificaExistenciaNaHierarquia() {
    this.carregandoService.mostra('verificaHierarquia');

    this.hierarquiaService.usuarioDentroDaHierarquia().subscribe(resp => {

      this.carregandoService.esconde('verificaHierarquia');

      if (!resp) {
        swal({
          title: 'Atenção!!!',
          text: 'Você não é membro de nenhum time!!!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).then(() => {});
      } else {
        this.estaNaHierarquia = true;
      }
    }, (erro) => {

      this.carregandoService.esconde('verificaHierarquia');
      this.notificacaoService.erro(erro);
    });
  }

  buscarOportunidades() {

    if (!this.crmSelecionado) {
      this.etapas = [];
      return;
    }

    this.filtroOportunidade.idCRM = this.crmSelecionado;

    localStorage.setItem('filtroOportunidade', JSON.stringify(this.filtroOportunidade));

    this.carregandoService.mostra('buscaOportunidades');
    this.carregando = true;

    this.oportunidadeService.consultarOportunidadesAgrupadasPorEtapas(this.filtroOportunidade).subscribe(dados => {
      this.etapas = dados;
      this.carregando = false;
      this.carregandoService.esconde('buscaOportunidades');
    }, (erro) => {
      this.carregandoService.esconde('buscaOportunidades');
      this.notificacaoService.erro(erro);
    });
  }

  buscarOportunidadesLista() {
    if (!this.crmSelecionado && this.visualizacaoSelecionada === 0) {
      this.oportunidades = [];
      return;
    }

    this.filtroOportunidade.idCRM = this.crmSelecionado === undefined || this.crmSelecionado === null ? 0 : this.crmSelecionado;

    localStorage.setItem('filtroOportunidade', JSON.stringify(this.filtroOportunidade));

    this.campoOrdenacao = this.filtroOportunidade.campoOrdenacao;
    this.ordenarDesc = this.filtroOportunidade.ascDesc === 'desc';

    this.carregandoService.mostra('buscaOportunidades');
    this.carregando = true;

    this.oportunidadeService.consultarOportunidadesComFiltro(this.filtroOportunidade).subscribe(dados => {
      this.oportunidades = dados;
      this.carregando = false;
      this.carregandoService.esconde('buscaOportunidades');
    }, (erro) => {
      this.carregandoService.esconde('buscaOportunidades');
      this.notificacaoService.erro(erro);
    });
  }

  gerarRelatorio(exportacao: number) {
    if (!this.crmSelecionado && this.visualizacaoSelecionada === 0) {
      this.oportunidades = [];
      return;
    }

    this.filtroOportunidade.exportacao = exportacao;

    this.carregandoService.mostra('relatorioOportunidade');

    this.relatorioService.relatorioDeOportunidades(this.filtroOportunidade).subscribe(resp => {
      if (exportacao === 0) {
        this.utilitarioService.openBlob(resp);
      }
      else {
        this.notificacaoService.sucesso('Relatório gerado com sucesso!!!');
        this.utilitarioService.saveBlob(resp, 'Oportunidades.xlsx');
      }

      this.carregandoService.esconde('relatorioOportunidade');
    }, (erro) => {
      const reader = new FileReader();

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement['result'];
        this.carregandoService.esconde('relatorioOportunidade');
        this.notificacaoService.erro(text);
      });

      // Start reading the blob as text.
      reader.readAsText(erro.error);
    });
  }

  async buscarFuncionario() {
    this.carregandoService.mostra('buscarFuncionario');

    this.funcionarioService.consultarFuncionarioPorId((await this.globalService.consultaUsuario()).id).subscribe(resp => {
      this.crmPadrao = resp.funilPadrao;

      if (this.filtroOportunidade.idCRM === 0) {
        this.crmSelecionado = resp.funilPadrao;
      } else {
        this.crmSelecionado = this.filtroOportunidade.idCRM;
      }

      this.buscarFunis();

      this.carregandoService.esconde('buscarFuncionario');
    }, (erro) => {
      this.carregandoService.esconde('buscarFuncionario');
      this.notificacaoService.erro(erro);
    });
  }

  buscarFunis() {
    this.carregandoService.mostra('buscaFunis');

    this.crmService.consultarCRM().subscribe(resp => {
      this.crms = resp;
      if (this.crms && this.crms.length > 0) {
        if (!this.crmSelecionado) {
          this.crmSelecionado = this.crms[0].id;
        }

        if (this.breakpointObserver.isMatched('(max-width: 767.98px)')) {
          this.visualizacaoSelecionada = 1;
        }

        this.trocouCRM();
      }
      this.carregandoService.esconde('buscaFunis');
    }, (erro) => {
      this.carregandoService.esconde('buscaFunis');
      this.notificacaoService.erro(erro);
    });
  }

  pesquisarOportunidade() {
    const filtroTemp = Object.assign({}, this.filtroOportunidade);
    const etapaSelecionada = this.filtroOportunidade.idEtapa;

    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(FiltroOportunidadeComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { filtro: filtroTemp, idCRM: this.crmSelecionado, crm: this.crms.find(c => c.id === this.crmSelecionado) },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: CRMFiltroOportunidade) => {
      if (result) {
        this.filtroOportunidade = result;
        this.filtroOportunidade.idEtapa = etapaSelecionada;

        if (this.visualizacaoSelecionada === 0) {
          this.buscarOportunidades();
        } else {
          this.buscarOportunidadesLista();
        }
      }
    });
  }

  filaDeCaptacao() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CardSemUsuarioComponent, {
      width: largura > 1300 ? '1300px' : (($('body').width()).toString() + 'px'),
      data: { idFunil: this.crmSelecionado },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(() => {
      if (this.visualizacaoSelecionada === 0) {
        this.buscarOportunidades();
      } else {
        this.buscarOportunidadesLista();
      }
    });
  }

  novoOportunidade() {
    const dialogRef = this.dialog.open(CadastrarOportunidadeComponent, {
      width: ($('body').width()).toString() + 'px',
      data: { crm: this.crms.find(p => p.id === this.crmSelecionado) },
      panelClass: 'modal-card'
    });
  }

  editarOportunidade(oportunidade) {
    this.router.navigate(['/crm/oportunidades/editar', oportunidade.id]);
  }

  excluirOportunidade(oportunidade: CRMOportunidade) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Oportunidade?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiOportunidade');
        this.oportunidadeService.excluir(oportunidade.id).subscribe(resp => {

          this.notificacaoService.sucesso('Oportunidade excluído com sucesso!!!');
          this.carregandoService.esconde('excluiOportunidade');
          this.buscarOportunidades();

        }, (erro) => {
          this.carregandoService.esconde('excluiOportunidade');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  ngOnDestroy(): void { }

  atividadeVencidaCorTexto(oportunidade: CRMOportunidade) {
    if (!oportunidade.dataPrimeiraAtividadeAtrasada) {
      if (oportunidade.dataUltimaAtividade) {
        return oportunidade.todasAtividadesConcluidas ? 'text-success' : 'text-info';
      }
      return 'text-secondary';
    }

    const resultado = this.utilitarioService.retornaDiferencaDeDias(
      new Date(oportunidade.dataPrimeiraAtividadeAtrasada),
      oportunidade.status === 0 ? new Date() : new Date(oportunidade.dtStatus)
    );

    if (resultado === 0) {
      return 'text-warning';
    } else if (resultado < 0) {
      return 'text-danger';
    } else {
      return oportunidade.todasAtividadesConcluidas ? 'text-success' : 'text-info';
    }
  }

  atividadeVencidaCorFundo(oportunidade: CRMOportunidade) {
    if (!oportunidade.dataPrimeiraAtividadeAtrasada) {
      return '';
    } else {
      const resultado = this.utilitarioService.retornaDiferencaDeDias(new Date(oportunidade.dataPrimeiraAtividadeAtrasada),
        oportunidade.status === 0 ? new Date() : new Date(oportunidade.dtStatus));
      return resultado < 0 ? 'oportunidade-atrasada' : '';
    }
  }

  retornaTooltip(oportunidade: CRMOportunidade) {
    if (!oportunidade.dataPrimeiraAtividadeAtrasada) {
      return oportunidade.dataUltimaAtividade ?
        ('Última atividade: ' + this.datePipe.transform(new Date(oportunidade.dataUltimaAtividade), 'dd/MM/yyyy HH:mm'))
        : 'Sem atividades...';
    } else {
      return oportunidade.dataPrimeiraAtividadeAtrasada ?
        ('Primeira atividade atrasada: ' + this.datePipe.transform(new Date(oportunidade.dataPrimeiraAtividadeAtrasada), 'dd/MM/yyyy HH:mm'))
        : 'Sem atividades...';
    }
  }

  drop(event: CdkDragDrop<CRMOportunidade[]>) {
    this.carregandoService.mostra('podeEditar');

    this.oportunidadeService.podeEditar(event.previousContainer.data[event.previousIndex].id).subscribe((resultado) => {
      this.carregandoService.esconde('podeEditar');

      if (!resultado.valor) {
        swal({
          title: 'Atenção!!!',
          text: 'A oportunidade está bloqueada!!!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).then(() => {

        });
      } else {
        if (event.previousContainer === event.container) {
          moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
          if (this.confirmarMudancaEtapa) {
            swal({
              title: 'Atenção!!',
              text: 'Deseja realmente alterar a etapa do card?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonClass: 'btn btn-info',
              cancelButtonClass: 'btn btn-danger',
              confirmButtonText: 'Sim',
              cancelButtonText: 'Não',
              buttonsStyling: false
            }).then((result) => {
              if (result.value) {
                this.alteraEtapa(event);
              }
            });
          } else {
            this.alteraEtapa(event);
          }
        }
      }
    }, (erro) => {
      this.carregandoService.esconde('podeEditar');
      this.notificacaoService.erro(erro);
    });
  }

  alteraEtapa(event: CdkDragDrop<CRMOportunidade[]>) {
    const oportunidade = event.previousContainer.data[event.previousIndex];
    oportunidade.idEtapa = Number(event.container.id.split('-')[1]);

    transferArrayItem(event.previousContainer.data,
      event.container.data,
      event.previousIndex,
      event.currentIndex);

    this.carregandoService.mostra('salvaCRMOportunidade');

    const oportunidadeParaSalvar = Object.assign({}, oportunidade);
    oportunidadeParaSalvar.valorEstimado = Number(oportunidadeParaSalvar.valorEstimado);

    this.oportunidadeService.alterarEtapa(oportunidadeParaSalvar).subscribe((novoId) => {
      this.notificacaoService.sucesso('Card salvo com sucesso!!!');
      this.carregandoService.esconde('salvaCRMOportunidade');

      this.buscarOportunidades();
    }, (erro) => {
      this.carregandoService.esconde('salvaCRMOportunidade');
      this.notificacaoService.erro(erro);
    });
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.oportunidades = this.oportunidades.sort((a, b) => {
        const isAsc = !this.ordenarDesc;
        switch (this.campoOrdenacao) {
        case 'titulo': return this.compare(a.titulo, b.titulo, isAsc);
        case 'dtabertura': return this.compare(Number(new Date(a.dtAbertura)), Number(new Date(b.dtAbertura)), isAsc);
        case 'contato': return this.compare(a.contatoNome.toLowerCase(), b.contatoNome.toLowerCase(), isAsc);
        case 'valorEstimado': return this.compare(a.valorEstimado, b.valorEstimado, isAsc);
        case 'dtExpectativa': return this.compare(Number(new Date(a.dtExpectativa)), Number(new Date(b.dtExpectativa)), isAsc);
        case 'etapa': return this.compare(a.etapaNome.toLowerCase(), b.etapaNome.toLowerCase(), isAsc);
        case 'dtAlteracao': return this.compare(Number(new Date(a.dtStatus)), Number(new Date(b.dtStatus)), isAsc);
        case 'status': return this.compare(this.buscarStatus(a).toLowerCase(), this.buscarStatus(b).toLowerCase(), isAsc);
        default: return 0;
        }
      });

    }
    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  selecionarTodos() {
    this.oportunidades.forEach(p => p.checado = this.selecaoTodos);
  }

  existeItensChecados() {
    return this.oportunidades.some(p => p.checado);
  }

  trocarUsuario() {
    const dialogRef = this.dialog.open(FuncionariosModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: { trabalharComCheckBox: true, mostrarBotoes: false, mostrarSomenteDoCRM: true },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe((result: Funcionario[]) => {
      if (result) {
        const transferencias: TransferenciaOportunidade[] = [];

        const oportunidadeParaTransferir = this.oportunidades.filter(p => p.checado);
        const qtd = oportunidadeParaTransferir.length;

        let qtdCada = Math.floor(qtd / result.length);

        let resto = qtd % result.length;
        let texto = 'Deseja realmente transferir ';
        let qtdPega = 0;

        for (let index = 0; index < result.length; index++) {
          let qtdParaPegar = qtdCada;
          if (index === 0 && qtdCada > 0) {
            qtdParaPegar += resto;
          } else if (qtdCada === 0 && resto > 0) {
            qtdParaPegar++;
            resto--;
          }

          if (qtdPega < qtd) {
            texto += (index === result.length - 1 ? ' e ' : (index > 0 ? ', ' : '')) + qtdParaPegar + ' card' + (qtdParaPegar == 1 ? '' : 's') + ' para o usuário ' + result[index].nome;
            transferencias.push({ idUsuario: Number(result[index].idFuncion), oportunidades: oportunidadeParaTransferir.slice(qtdPega, qtdPega + qtdParaPegar) });
            qtdPega += qtdParaPegar;
          }
        }

        swal({
          title: 'ATENÇÃO!',
          text: texto + '?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          buttonsStyling: false
        }).then((res) => {
          if (res.value) {
            this.carregandoService.mostra('trocarUsuario');

            this.oportunidadeService.trocarUsuario({ transferencias: transferencias }).subscribe(resp => {
              this.notificacaoService.sucesso('Transferência executada com sucesso!!!');

              this.buscarOportunidadesLista();

              this.carregandoService.esconde('trocarUsuario');
            }, (erro) => {
              this.carregandoService.esconde('trocarUsuario');
              this.notificacaoService.erro(erro);
            });
          }
        });
      }
    });
  }

  alterarStatus() {
    const dialogRef = this.dialog.open(AlterarStatusOportunidadeComponent, {
      data: {
        tipoResposta: 0, lote: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((resp) => {
      if (resp) {
        swal({
          title: 'Atenção!!',
          text: 'Deseja realmente alterar o status dos cards selecionados?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
            const oportunidadeParaAlterar = this.oportunidades.filter(p => p.checado);
            this.carregandoService.mostra('alteraStatusEmLote');

            this.oportunidadeService.AlterarStatusEmLote(oportunidadeParaAlterar.map(p => p.id), resp.status, resp.idResposta).subscribe(resp => {
              this.notificacaoService.sucesso('Oportunidades alteradas com sucesso!!!');

              this.buscarOportunidadesLista();

              this.carregandoService.esconde('alteraStatusEmLote');
            }, (erro) => {
              this.carregandoService.esconde('alteraStatusEmLote');
              this.notificacaoService.erro(erro);
            });
          }
        });
      }
    });
  }

  restaurarFiltros() {
    this.filtroOportunidade = {
      campoOrdenacao: 'dtabertura', ascDesc: 'desc', tags: [],
      idCRM: 0, status: 0, idResposta: 0, oportunidade: '', idCanalDeVenda: 0, periodo: 0,
      dtInicio: new Date(), dtFim: new Date(), idOrdenacao: 3, usuarios: [-1], cidade: '', idEtapa: 0, nomeContato: '', anotacaoAtividade: '',
      idOportunidade: null, numeroInstalacaoGeradora: '', numeroInstalacaoRecebedora: '', numeroOrcamento: ''
    };

    this.crmSelecionado = !this.crmPadrao || this.crmPadrao === null ?
      (!this.crms || this.crms === null || this.crms.length === 0 ? 0 : this.crms[0].id) : this.crmPadrao;

    if (this.visualizacaoSelecionada === 0) {
      this.buscarOportunidades();
    } else {
      this.buscarOportunidadesLista();
    }
  }

  buscarEtapas() {
    if ((!this.crmSelecionado || this.crmSelecionado === null) && this.visualizacaoSelecionada === 0) {
      this.crmSelecionado = 0;
      this.etapas = [];
      this.filtroOportunidade.idEtapa = 0;
    } else {
      if (!this.crmSelecionado || this.crmSelecionado === null) {
        this.etapasFiltro = [];
        this.filtroOportunidade.idEtapa = 0;
        this.trocouEtapa();
      } else {
        this.carregandoService.mostra('buscarEtapas');
        this.crmService.consultarEtapasDoCRM(this.crmSelecionado).subscribe(ets => {
          this.etapasFiltro = ets;
          let etapaTodas = new CRMEtapaFunil();
          etapaTodas.id = 0;
          etapaTodas.descricao = 'Todas';
          this.etapasFiltro.unshift(etapaTodas);
          this.carregandoService.esconde('buscarEtapas');

          if (!this.etapasFiltro.some(p => p.id === this.filtroOportunidade.idEtapa)) {
            this.filtroOportunidade.idEtapa = 0;
          }

          this.trocouEtapa();
        }, (erro) => {
          this.carregandoService.esconde('buscarEtapas');
          this.notificacaoService.erro(erro);
        });
      }
    }
  }

  trocouEtapa() {
    if (this.visualizacaoSelecionada === 0) {
      this.buscarOportunidades();
    } else {
      this.buscarOportunidadesLista();
    }
  }
}
